
import * as XLSX from 'xlsx';

/**
 * Extract categories from an Excel worksheet
 */
export const extractCategoriesFromSheet = (worksheet: XLSX.WorkSheet): string[] => {
  const data = XLSX.utils.sheet_to_json<{
    name: string;
    category_name?: string;
  }>(worksheet, { header: 'A', defval: null });
  
  console.log('Raw category sheet data:', data);
  
  // Skip the header row if it exists (look for common header names)
  const startRow = data[0] && 
    (data[0].name?.toLowerCase() === 'name' || 
     data[0].name?.toLowerCase() === 'category_name' ||
     data[0].name?.toLowerCase() === 'category') ? 1 : 0;
  
  return data.slice(startRow).map((row: any) => {
    // Find the correct column for the category name
    const getColumnValue = (possibleNames: string[]) => {
      for (const key of Object.keys(row)) {
        if (possibleNames.includes(key.toLowerCase())) {
          return row[key];
        }
      }
      return null;
    };
    
    // Extract category name handling various column name formats
    const categoryName = getColumnValue(['name', 'category_name', 'category', 'categoryname']);
    
    console.log('Extracted category:', categoryName);
    
    // Only return valid category names
    if (!categoryName || typeof categoryName !== 'string' || categoryName.trim() === '') {
      return null;
    }
    
    return categoryName.trim();
  }).filter((category): category is string => category !== null);
};
